import { Component } from 'react';

import styles from './ConfirmationStatement.module.css';

export class ConfirmationStatement extends Component {
    handleClick = () => {
        const { showQuestionHandler } = this.props;

        showQuestionHandler(true);
    };

    render() {
        const { children, showQuestion } = this.props;

        if (showQuestion) {
            return null;
        }

        return (
            <div
                className={styles.ConfirmationStatement}
                onClick={this.handleClick}
            >
                {children}
            </div>
        );
    }
}
